export default {
  noMattersInProfile: 'Este {profile} no cuenta con {matters}.',
}
